import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ScrollContainer from './ScrollContainer'
import { WithTranslation, withTranslation } from 'react-i18next';

type AppLayoutInternalProps = {
  toolbar: React.ReactElement
  layerList: React.ReactElement
  layerEditor?: React.ReactElement
  map: React.ReactElement
  bottom?: React.ReactElement
  modals?: React.ReactNode
  simplePanel?: React.ReactElement
} & WithTranslation;

class AppLayoutInternal extends React.Component<AppLayoutInternalProps> {
  static childContextTypes = {
    reactIconBase: PropTypes.object
  }

  getChildContext() {
    return {
      reactIconBase: { size: 14 }
    }
  }

  render() {
    document.body.dir = this.props.i18n.dir();

    const isSimple = !!this.props.simplePanel;

    return <div className={classnames("studio-layout", {"studio-layout--simple": isSimple})}>
      {this.props.toolbar}
      <div className="studio-layout-main">
        {isSimple
          ? <div className="studio-layout-simple">
            <ScrollContainer>
              {this.props.simplePanel}
            </ScrollContainer>
          </div>
          : <>
            <div className="studio-layout-list">
              {this.props.layerList}
            </div>
            <div className="studio-layout-drawer">
              <ScrollContainer>
                {this.props.layerEditor}
              </ScrollContainer>
            </div>
          </>
        }
        {this.props.map}
      </div>
      {this.props.bottom && <div className="studio-layout-bottom">
        {this.props.bottom}
      </div>
      }
      {this.props.modals}
    </div>
  }
}

const AppLayout = withTranslation()(AppLayoutInternal);
export default AppLayout;
